/**
 * Adapter puro das métricas pessoais (Tela 3 Pendências · aba Métricas · Item
 * 346 D3). Formatação honesta dos números reais do operador — sem React.
 */

/**
 * Formata minutos da pendência vencida mais antiga em rótulo humano pt-BR.
 * `null` → "—" (sem vencidas). `< 60` → "Nm"; senão "Xh Ym" (ou "Xd Yh"
 * acima de 24h) — leitura rápida do "há quanto tempo a mais antiga venceu".
 */
export function formatOldestOverdue(minutes: number | null): string {
  if (minutes === null) return '—';
  if (minutes < 1) return 'agora';
  if (minutes < 60) return `${minutes}min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    const rem = minutes % 60;
    return rem === 0 ? `${hours}h` : `${hours}h ${rem}min`;
  }
  const days = Math.floor(hours / 24);
  const remH = hours % 24;
  return remH === 0 ? `${days}d` : `${days}d ${remH}h`;
}
